import React, { useEffect, useState } from "react";
import axios from "axios";
import Button from "@mui/material/Button";
import { useDispatch } from "react-redux";
import { editAttribute } from "../../Redux/features/Attributes/attributesSlice";
import CrossIcon from "../../Assests/Dashboard/cross.svg";
import { BASE_URL, ADD_ATTRIBUTE } from "../../Constants/Config";
import EditIcon from "../../Assests/Category/editIcon.svg";
import { Box, Modal } from "@mui/material";
import { useAuthDetails } from "../../Common/cookiesHelper";
import { ToastifyAlert } from "../../CommonComponents/ToastifyAlert";
import CircularProgress from "@mui/material/CircularProgress";
import PasswordShow from "../../Common/passwordShow";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useSelector } from "react-redux";

const EditDeliveryAddress = ({ attribute, allattributes }) => {
  const [nameExists, setNameExists] = useState("");
  const [old_title, setold_title] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [newAttribute, setNewAttribute] = useState("");
  const [submitmessage, setsubmitmessage] = useState("");

  const { LoginGetDashBoardRecordJson, userTypeData } = useAuthDetails();
  let AuthDecryptDataDashBoardJSONFormat = LoginGetDashBoardRecordJson;
  const merchant_id = AuthDecryptDataDashBoardJSONFormat?.data?.merchant_id;
  const openModal = () => {
    setShowModal(true);
    setNewAttribute(attribute.title);
    setold_title(attribute.title);
    setErrorMessage("");
  };
  const { handleCoockieExpire, getUnAutherisedTokenMessage, getNetworkError } =
    PasswordShow();
  const closeModal = () => {
    setShowModal(false);
  };
  const [loader, setLoader] = useState(false);

  const dispatch = useDispatch();
  const changeTittleHandler = (inputValue) => {
    const regex = /^[A-Za-z0-9 ]*$/;
    const space = /^(?!\s).*/;
    if (space.test(inputValue)) {
      if (regex.test(inputValue) || inputValue === "") {
        setNewAttribute(inputValue);
        const nameExists = allattributes.some(
          (item) => item.title === inputValue && item.id !== attribute.id
        );
        if (nameExists) {
          setErrorMessage("Attribute name already exists");
          setNameExists(true);
        } else {
          setErrorMessage("");
          setNameExists(false);
        }
      } else {
        setErrorMessage("Special characters are not allowed");
      }
    }
  };
  const handleEditAttribute = async () => {
    if (nameExists) {
      return false;
    }
    if (!newAttribute.trim()) {
      setErrorMessage("Title is required");
      return;
    }
    try {
      const editItem = {
        merchant_id: merchant_id,
        varient_id: attribute.id,
        title: newAttribute,
        old_title: attribute.title,
        login_employee_id: LoginGetDashBoardRecordJson?.employee_id
          ? LoginGetDashBoardRecordJson?.employee_id
          : null,
        token_id: userTypeData?.token_id,
        login_type: userTypeData?.login_type,
      };
      const data = editItem;
      // console.log(data);
      setLoader(true);
      const response = await axios.post(BASE_URL + ADD_ATTRIBUTE, editItem, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userTypeData?.token}`,
        },
      });
      if (response) {
        dispatch(editAttribute({ id: attribute.id, title: newAttribute }));
        ToastifyAlert("Updated Successfully", "success");
        setShowModal(false);
      } else {
        setsubmitmessage(response.data.message);
      }
    } catch (error) {
      if (error?.status == 401 || error?.response?.status === 401) {
        getUnAutherisedTokenMessage();
        handleCoockieExpire();
      } else if (error?.status == "Network Error") {
        getNetworkError();
      }
    }
    setLoader(false);
  };

  setTimeout(() => {
    setsubmitmessage("");
  }, 4000);

  const handleClose = () => setShowModal(false);

  const myStyles = {
    // width: "60%",
    position: "absolute",
    top: "47%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    fontFamily: "'CircularSTDMedium', sans-serif !important",
  };

  const handleKeyPress = (event) => {
    if (event.key === ",") {
      event.preventDefault();
    }
  };

  const [defaultList, setDefaultList] = useState([]);
  const qcList = useSelector((state) => state.qclist);

  useEffect(() => {
    if (qcList?.qcList?.length) {
      const defaultList = qcList.qcList.filter((item) => {
        return item.type === "Attribute" && item.show_dropdown === "1";
      });
      setDefaultList(() => [...defaultList]);
    }

    return () => {
      setDefaultList([]);
    };
  }, [qcList]);

  return (
    <>
      <div>
        <Button
          className="modal-main-button edit-delivery-address-button attributeEdit_BTN"
          onClick={openModal}
        >
          <img src={EditIcon} alt="" className="" />
        </Button>

        <Modal
          open={showModal}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            className="view-category-item-modal"
            sx={{ width: { xs: "95%", md: "60%" } }}
            style={myStyles}
          >
            <div
              className="q-add-categories-section-header text-[18px]"
              style={{
                justifyContent: "space-between",
                fontFamily: "CircularSTDBook",
              }}
            >
              <span style={{ cursor: "unset" }}>Update Attribute</span>

              <div>
                <img
                  src={CrossIcon}
                  alt="icon"
                  className="  quic-btn-cancle w-6 h-6 cursor-pointer"
                  onClick={() => handleClose()}
                />
              </div>
            </div>

            <div className="view-category-item-modal-header">
              <div
                className="title_attributes_section"
                style={{ margin: "1rem 1rem" }}
              >
                <label className="mb-2">Title</label>

                <Autocomplete
                  id="size-small-standard"
                  size="small"
                  options={defaultList}
                  freeSolo
                  getOptionLabel={(option) => {
                    // Check if the option is an object with a name property
                    if (typeof option === "object" && option.name) {
                      return option.name;
                    }
                    // Handle other types of options, e.g., strings
                    return typeof option === "string" ? option : "";
                  }}
                  value={newAttribute}
                  onChange={(event, newValue) => {
                    changeTittleHandler(newValue?.name || "");
                  }}
                  renderOption={(props, option, { index }) => (
                    <li {...props} key={index}>
                      {typeof option === "object" ? option.name : option}
                    </li>
                  )}
                  // disabled={props.controltext}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      maxLength={35}
                      onKeyPress={handleKeyPress}
                      className="suggestlist_input MuiAutocomplete-option"
                      name="brand"
                      value={newAttribute}
                      placeholder="Enter attribute title"
                      onChange={(e) => changeTittleHandler(e.target.value)}
                      inputProps={{
                        ...params.inputProps,
                        inputMode: "text", // This sets the input mode for text input
                        autoCapitalize: "words", // This enables capitalizing the first letter of each word
                      }}
                    />
                  )}
                />
                <span className="input-error">
                  {errorMessage !== "" ? errorMessage : ""}
                </span>
              </div>
            </div>

            <div className="q-add-categories-section-middle-footer">
              <button
                onClick={handleEditAttribute}
                className="quic-btn quic-btn-save attributeUpdateBTN"
                disabled={loader}
              >
                {loader ? (
                  <>
                    <CircularProgress
                      color={"inherit"}
                      className="loaderIcon"
                      width={15}
                      size={15}
                    />{" "}
                    Update
                  </>
                ) : (
                  "Update"
                )}
              </button>
              <button onClick={closeModal} className="quic-btn quic-btn-cancle">
                Cancel
              </button>
            </div>
          </Box>
        </Modal>
      </div>
    </>
  );
};
export default EditDeliveryAddress;
